module.exports = (__parcel__import__("6W711")).then(() => parcelRequire('ahP7X'));